import styles from "./Home.module.css";
import MenuBar from "../MenuBar/MenuBar";
import Main from "../Main/Main";
import ImageDetail from "../ImageDetail/ImageDetail";
import { useSelector } from "react-redux";
import BidPanel from "../BidPanel/BidPanel";

export default function Home() {
  const bannerModal = useSelector((state) => state.bannerModal);
  const bidPanel = useSelector((state) => state.bidPanel);

  return (
    <section className={styles.outer}>
      <MenuBar />
      <Main />
      {bannerModal && <ImageDetail />}
      {bidPanel.userId && bidPanel.imageId && bidPanel.celebId && <BidPanel />}
    </section>
  );
}
